import PropTypes from "prop-types";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import isSidebarMenuItemActive from "./sidebarMenuHelpers";
import getSidebarMenuItems from "./sidebarMenuConfig";

const SidebarMenuLinks = ({ collapsed = false, onNavigate, className = "" }) => {
    const location = useLocation();
    const { t } = useTranslation("sidebar");
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const menuItems = getSidebarMenuItems(t);

    return (
        <ul className={`relative list-none p-0 font-regular text-white ${className}`} data-tour="sidebar-nav">
            {menuItems.map(({ to, text, icon, activeIcon, tourId }, index) => {
                const isActive = isSidebarMenuItemActive(to, location.pathname);
                const isHovered = hoveredIndex === index;
                const isSettingsItem = text === t("settings");

                return (
                    <Link
                        key={to}
                        to={to}
                        data-tour={tourId}
                        onClick={onNavigate}
                        className={`block py-1.5 no-underline transition-all duration-300 ease-in-out ${
                            collapsed ? "mx-1 rounded-xl" : "mr-2 rounded-r-[28px] xl:mr-4 2xl:mr-8"
                        } ${
                            isActive
                                ? "bg-white text-black shadow-[0_0_1.5rem_rgba(0,0,0,0.2)]"
                                : isHovered
                                  ? "bg-[rgba(255,255,255,0.1)]"
                                  : "bg-transparent text-white"
                        }`}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                        title={text}>
                        <div
                            className={`flex items-center p-2 ${
                                collapsed
                                    ? "justify-center"
                                    : "justify-start gap-1.5 pl-3 xl:gap-2 xl:pl-5 2xl:gap-[6px] 2xl:pl-10"
                            }`}>
                            {isSettingsItem ? (
                                <img
                                    src={isActive ? activeIcon : icon}
                                    width={25}
                                    alt=""
                                    className={collapsed ? "" : "-ml-1"}
                                />
                            ) : (
                                <img src={isActive ? activeIcon : icon} width={20} alt="" />
                            )}
                            {!collapsed ? (
                                <span className="truncate text-xs xl:text-sm 2xl:text-base">{text}</span>
                            ) : null}
                        </div>
                    </Link>
                );
            })}
        </ul>
    );
};

SidebarMenuLinks.propTypes = {
    collapsed: PropTypes.bool,
    onNavigate: PropTypes.func,
    className: PropTypes.string,
};

export default SidebarMenuLinks;
